import { action, observable } from 'mobx'
import { BoardReportRequest } from '../requests/BoardReportRequest'

class BoardReportStore {
  /** Danh sách báo cáo **/
  @observable boardReportList = []
  @observable boardReportTotalPage = undefined
  @observable boardReportTotalCount = undefined
  @observable boardReportPageIndex = 0
  @observable selectedBoardReport = {}
  @observable boardReportCommentList = []
  @observable boardReportCommentSortByDate = 'ASC'
  @observable selectedBoardReportAttachment = undefined

  @observable queryParams = {
    page: 0,
    size: 10,
    title: null,
    content: null,
    code: null,
    user_created: null,
    createdAtFrom: null,
    createdAtTo: null,
  }

  @action clearQueryParams = () => {
    this.queryParams = {
      page: 0,
      size: 10,
      title: null,
      content: null,
      code: null,
      user_created: null,
      createdAtFrom: null,
      createdAtTo: null,
    }
  }

  @action clearBoardReportList = () => {
    this.boardReportList.length = 0
    this.boardReportCommentList.length = 0
  }

  @action clearSelectedBoardReport = () => {
    this.selectedBoardReport = {}
    this.selectedBoardReportAttachment = undefined
  }

  @action clearBoardReportFilter = () => {
    this.boardReportPageIndex = 0
  }

  @action setQueryParams = payload => {
    this.queryParams = {
      ...payload,
      size: payload.size ? parseInt(payload.size) : 10,
      page: payload.page ? parseInt(payload.page) : 0,
    }
  }
  @action getBoardReportList = () => {
    return new Promise((resolve, reject) => {
      BoardReportRequest.getBoardReportList(this.queryParams)
        .then(response => {
          this.boardReportList = response.data.data
          this.boardReportTotalPage = response.data.total_page
          this.boardReportTotalCount = response.data.total_count
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action createBoardReport = boardReportInfo => {
    return new Promise((resolve, reject) => {
      BoardReportRequest.createBoardReport(boardReportInfo)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action updateBoardReport = (code, boardReportInfo) => {
    return new Promise((resolve, reject) => {
      BoardReportRequest.updateBoardReport(code, boardReportInfo)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action deleteBoardReportByCode = code => {
    return new Promise((resolve, reject) => {
      BoardReportRequest.deleteBoardReportByCode(code)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getBoardReportByCode = code => {
    return new Promise((resolve, reject) => {
      BoardReportRequest.getBoardReportByCode(code)
        .then(response => {
          this.selectedBoardReport = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getBoardReportComment = internal_document_code => {
    return new Promise((resolve, reject) => {
      BoardReportRequest.getBoardReportComment(internal_document_code)
        .then(response => {
          this.boardReportCommentList = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action clearBoardReportCommentList = () => {
    this.boardReportCommentList.length = 0
  }

  @action createBoardReportComment = (code, data) => {
    return new Promise((resolve, reject) => {
      BoardReportRequest.createBoardReportComment(code, data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action deleteBoardReportComment = (code, comment_id) => {
    return new Promise((resolve, reject) => {
      BoardReportRequest.deleteBoardReportComment(code, comment_id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default new BoardReportStore()
